import styled from "styled-components";

import clipboardList from "../../../icons/clipboard-list.svg";
import compare from "icons/compare.svg";

export const IconListItem = styled.li`
  padding-left: 20px;

  ${({ icon }) => {
    if (icon === "clipboard-list") {
      return `background: url("${clipboardList}") no-repeat 0 2px`;
    }

    if (icon === "compare") {
      return `background: url("${compare}") no-repeat 0 4px`;
    }
  }}
`;
